<div fxLayout="row wrap"
     fxLayout.xs="column"
     class="mb-2">
     <div fxFlex="50%;"
          fxFlex.xs="100%">
          <div class="header">Filter</div>
     </div>
     <div fxFlex="50%;"
          fxFlex.xs="100%"
          fxLayoutAlign="end end">
          <mat-icon (click)="close('close')">close</mat-icon>
     </div>
</div>

<div fxLayout="row wrap"
     class="mt10"
     fxLayout.xs="column">
     <div fxFlex="100%;"
          fxFlex.xs="100%">
          <div class="filterTitle">Dates</div>
     </div>
</div>
<br />
<div fxLayout="row wrap"
     fxLayout.xs="column"
     class="filterValue"
     *ngFor="let filterDate of eventDateFilter ">
     <div fxFlex="70%;"
          fxFlex.xs="100%">
          <div (click)="selectDateFilter(filterDate)">{{filterDate}}</div>
     </div>
     <div fxFlex="30%;"
          fxFlex.xs="100%"
          fxLayoutAlign="end end">
          <img src="./assets/bbraun/manageEvent/filter-tick.svg"
               *ngIf="dateFilter[0].name==filterDate"
               alt="icon" />
     </div>
</div>
<form [formGroup]="filterForm"
      class="signin-form"
      fxLayout="column">

     <div fxLayout="row wrap"
          fxLayout.xs="column">
          <div fxFlex="100%;"
               fxFlex.xs="100%">
               <label>Start date</label>
               <mat-form-field class="full-width"
                               appearance="outline">
                    <input matInput
                           readonly
                           [matDatepicker]="picker"
                           formControlName="startDate">
                    <mat-datepicker-toggle matSuffix
                                           [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
               </mat-form-field>
          </div>
          <div fxFlex="100%;"
               fxFlex.xs="100%">
               <label>End date</label>
               <mat-form-field class="full-width"
                               appearance="outline">
                    <input matInput
                           readonly
                           [min]="this.filterForm.get('startDate').value"
                           [matDatepicker]="endPicker"
                           formControlName="endDate">
                    <mat-datepicker-toggle matSuffix
                                           [for]="endPicker"></mat-datepicker-toggle>
                    <mat-datepicker #endPicker></mat-datepicker>
               </mat-form-field>
          </div>
     </div>
</form>
<div fxLayout="row wrap"
     fxLayout.xs="column">
     <div fxFlex="100%;"
          fxFlex.xs="100%">
          <div class="filterDiveder"></div>
     </div>
</div>
<div fxLayout="row wrap"
     *ngIf="data.isFrom !='eventparticipant'"
     fxLayout.xs="column">
     <div fxFlex="100%;"
          fxFlex.xs="100%">
          <div class="filterTitle">Therapetics</div>
     </div>
</div>
<div *ngIf="data.isFrom !='eventparticipant'">
     <div fxLayout="row wrap"
          fxLayout.xs="column"
          class="filterValue"
          *ngFor="let therapetic of eventTherapeticsFilter "
          (click)="therapetic.enable = !therapetic.enable">
          <div fxFlex="70%;"
               fxFlex.xs="100%">
               <div>
                    {{therapetic.name}}</div>
          </div>
          <div fxFlex="30%;"
               fxFlex.xs="100%"
               fxLayoutAlign="end end">
               <img src="./assets/bbraun/manageEvent/filter-tick.svg"
                    *ngIf="therapetic.enable"
                    alt="icon" />
          </div>
     </div>
</div>
<div fxLayout="row wrap"
     fxLayout.xs="column"
     class="mb-2 mt-2">
     <div fxFlex="70%;"
          fxLayoutAlign="end end"
          fxFlex.xs="100%">
          <button mat-button
                  type="button"
                  (click)="close('clear')">Clear Filter</button>
     </div>
     <div fxFlex="30%;"
          fxFlex.xs="100%"
          fxLayoutAlign="end end">
          <button mat-raised-button
                  (click)="applyFilter()"
                  color="accent">Apply</button>
     </div>
</div>